<template>
  <transition name="modal">
    <div id="modal">
      <div class="modal_recherche__form_results flex-col-fJstart-fAcenter">
        <div class="recherche flex-fJstart-fAcenter">
          <input
            id="edit-query"
            ref="rechercheModal"
            v-model="searchValue"
            :title="labels.titleSearch"
            pattern=".{3,}"
            autocorrect="none"
            autocomplete="autocomplete"
            spellcheck="false"
            type="search"
            name="query"
            size="60"
            maxlength="60"
            :placeholder="labels.placeholderSearch"
            required="required"
            aria-required="true"
            class="form-search required"
            @keyup="autocomplete($event)"
          >
          <button
            id="edit-submit"
            type="submit"
            name="op"
            class="icon-search button js-form-submit form-submit"
            v-html="labels.buttonSearch"
            @click="redirectTousResultats"
          />
        </div>
        <div class="modal_recherche__results">
          <span
            class="popupClose pixel_16 icon-cross"
            @click="$emit('close')"
          />
          <div class="listeProduits modal_recherche__results__container">
            <div class="modal_recherche__results__container_title">
              <h2 v-html="labels.productTitle" />
              <p v-if="totalResults > 0">
                <a @click="redirectTousResultats">{{ labels.resultLink }} ({{ totalResults }})</a>
              </p>
            </div>
            <div class="productsList modal_recherche__results__container_content">
              <a
                v-for="article in articles"
                :key="article.id"
                :href="article.link"
                class="catalogArticle"
              >
                <div class="ligneArticle_image">
                  <span
                    v-if="article.image != ''"
                    class="flex-fJcenter-fAcenter mainImage"
                  >
                    <img
                      :src="article.image.src"
                      :alt="article.image.libelle"
                      :title="article.image.libelle"
                    >
                  </span>
                  <span
                    v-else
                    class="flex-fJcenter-fAcenter mainImage"
                    v-html="labels.imageDefault"
                  />
                </div>
                <div class="ligneArticle_detail flex-fJbetween-fAstart">
                  <div class="produitDescriptif flex-col-fJbetween-fAstart">
                    <p class="title">
                      <span
                        class="ligneArticle_desi1"
                        v-html="article.designation"
                      />
                    </p>
                    <p
                      v-if="paramArray.SHOW_CODE_ARTICLE"
                    >
                      <span
                        class="infoDetail"
                        v-html="labels.refLibelle"
                      />
                      <span
                        class="infoDetail"
                        v-html="article.codeArticle"
                      />
                    </p>
                    <p
                      v-if="article.isVariant || (article.hasDeclinaisons && !paramArray.HIDE_VARIANTES)"
                      class="blocVariant declinaisonConteneur"
                    >
                      <span
                        class="icon-cards"
                      />
                      <span
                        v-html="article.isVariant ? labels.variantLibelle : labels.declinaisonLibelle "
                      />
                    </p>
                  </div>
                </div>
                <div
                  v-if="paramArray.SHOW_STOCK !== 'none' && article.infoStock.INFO_STOCK"
                  class="ligneArticle_tarif flex-fJcenter-fAcenter"
                >
                  <div class="blocStock">
                    <p
                      class="flex-col-fJbetween-fAstretch"
                      :class="'stock_'+article.infoStock.INFO_STOCK.toLowerCase()"
                    >
                      <span
                        v-if="paramArray.SHOW_STOCK === 'picto'"
                        v-html="libelleStock[article.infoStock.INFO_STOCK.toLowerCase()]"
                        class="libelleStock"
                      />
                      <span
                        v-else-if="paramArray.SHOW_STOCK === 'value'"
                      > {{ labels.stockLibelle }}
                        {{ article.infoStock.NB_STOCK }}
                        <span
                          class="unit"
                          v-html="article.uniteStock"
                        />
                      </span>
                      <span
                        v-else
                        class="libelleStock"
                      >
                        {{ article.infoStock.NB_STOCK }}
                        <span
                          class="unit"
                          v-html="article.uniteStock"
                        />
                      </span>
                      <span
                        v-if="paramArray.SHOW_STOCK === 'all' || paramArray.SHOW_STOCK === 'picto'"
                        class="pictoStock flex-fJstart-fAcenter"
                      >
                        <span /><span /><span />
                      </span>
                    </p>
                  </div>
                </div>
              </a>
            </div>
          </div>
          <div
            v-if="categories != ''"
            class="listeCategories modal_recherche__results__container"
          >
            <div class="modal_recherche__results__container_title">
              <h2 v-html="labels.categoryTitle" />
            </div>
            <div class="categoryList modal_recherche__results__container_content">
              <div class="flex-wrap-fJstart-fAStart">
                <a
                  v-for="categorie in categories"
                  :key="categorie.id"
                  :href="categorie.link"
                  v-html="categorie.libelle"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios'

export default {
  props: {
    showModal: Boolean,
    searchToken: {
      type: String,
      default: ''
    },
    labels: {
      type: Object,
      default() {
        return {}
      }
    },
    libelleStock: {
      type: Object,
      default() {
        return {}
      }
    },
    paramArray: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data: function() {
    return {
      articles: null,
      categories: null,
      totalResults: 0,
      searchValue: this.searchToken
    }
  },
  mounted() {
    this.$refs.rechercheModal.focus()
    this.searchValue = this.searchToken
    this.autocomplete()
  },
  methods: {
    autocomplete: function(e) {
      if (typeof e !== 'undefined' && e.keyCode == 27) {
        this.$emit('close')
        return
      } else if (typeof e !== 'undefined' && e.keyCode == 13) {
        this.redirectTousResultats()
        return
      }
      new Promise((resolve, reject) => {
        axios.get('/rest/recherche/' + this.searchValue).then(
          response => {
            resolve(response.data)
          },
          response => {
            reject(response)
          }
        )
      }).then(
        response => {
          this.articles = response['articles']
          this.categories = response['categories']
          this.totalResults = response['totalResults']
        },
        response =>
          console.log('autocomplete Error : ' + JSON.stringify(response))
      )
    },
    redirectTousResultats: function() {
      window.location = '/recherche?query=' + this.searchValue
    }
  }
}
</script>
